'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageSliderDirective = undefined;

var _tpl = require('./tpl.html');

var _tpl2 = _interopRequireDefault(_tpl);

var _index = require('./index.js');

var _index2 = _interopRequireDefault(_index);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageSliderDirective = function ImageSliderDirective() {
  return {
    restrict: 'E',
    template: _tpl2.default,
    controller: _index2.default,
    controllerAs: '$ctrl',
    scope: {},
    bindToController: {
      images: '=',
      index: '='
    }
  };
};

exports.ImageSliderDirective = ImageSliderDirective;


//////////////////
// WEBPACK FOOTER
// ./product-list/image-slider/image-slider.directive.js
// module id = 494
// module chunks = 0